var map = {
	"./EagleGlobalMarkets-logo.svg": "2055",
	"./FXView-logo.svg": "9d79",
	"./ICMTrader-logo.svg": "50f0",
	"./WLGravity-logo.svg": "f62d",
	"./Zulu-logo.svg": "1892",
	"./dxtrade-logo.svg": "4f8e",
	"./icm-logo.svg": "637d",
	"./icmmena-logo.svg": "e727",
	"./tradecore-logo.svg": "0272"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17db";